import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

type ModalAlertaHomeProps = {
  visivel: boolean;
  fechar: any;
};

type ModalAlertaHomeState = {
  enabled: boolean;
};

class ModalAlertaHome extends React.Component<
  ModalAlertaHomeProps,
  ModalAlertaHomeState
> {
  constructor(props: ModalAlertaHomeProps) {
    super(props);

    this.fechar = this.fechar.bind(this);
  }

  fechar(): any {
    if (this.props.fechar) {
      this.props.fechar();
    }
  }

  render(): any {
    if (
      new Date() > new Date("2020-04-21T08:00:00") &&
      new Date() < new Date("2020-04-21T20:00:00")
    ) {
      return (
        <Dialog open={this.props.visivel}>
          <DialogContent>
            <div className="modal disponivel" id="subs-modal">
              <p className="title">Prezados clientes</p>
              <p className="menu-item">
                Estamos atualizando a nossa plataforma para que você tenha uma
                experiência de compras ainda melhor.
                <br />
                <br />
                Por isso, hoje, dia 21/04, das 8h às 18h, nossas prateleiras
                digitais serão readequadas.
                <br />
                <br />
                Em breve, você poderá aproveitar todo o sabor e frescor do Oba,
                com um serviço on-line cada vez melhor.
                <br />
                <br />
                Agradecemos a compreensão.
              </p>
              <div className="menu">
                <button onClick={this.fechar}>Entendi</button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      );
    } else {
      return <></>;
    }
  }
}

export default ModalAlertaHome;
